<section class="container-fluid bg-black">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-10 offset-md-1  my-5 text-white">
          <div class="mb-4">
            <p class="fs-5">
              Family Health Advantage (“FHAdvantage”) is a discount medical plan, it is NOT health insurance coverage. 
              FHAdvantage offers discounts on chiropractic services provided by chiropractors that have contracted with FHAdvantage (“Participating Providers”). 
              The range of discounts for chiropractic services provided under FHAdvantage will vary depending on the Participating Provider and the services the Member receives. 
              FHAdvantage does not make payments to Participating Providers for chiropractic services received by Members under FHAdvantage. 
              Members are obligated to pay Participating Providers for all chiropractic services but will receive a discount from Participating Providers. Members and prospective members may obtain additional information about and assistance with FHAdvantage and receive an up-to-date list of providers participating in FHAdvantage by contacting FHAdvantage.
            </p>
          </div>
        </div>
      </div>
    </div>
</section>
<div class="container-fluid bg-dark text-light d-flex justify-content-between">
    <nav class="container-fluid px-0 d-flex justify-content-between">
        <div class="">  
           <ul class="nav mb-2 mb-lg-0">
                <li class="nav-item nav-text fs-7 mt-2">
                    &copy; {{year}} Family Health Advantage
                </li>
            </ul>
        </div>
        <div class="">
            <ul class="nav mb-2 mb-lg-0">
                <li class="nav-item">
                    <a href="#" class="nav-link link-light">
                        <i class="bi-facebook"></i>
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link link-light">
                        <i class="bi-instagram"></i>
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link link-light">
                        <i class="bi-youtube"></i>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</div>